import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs-compat';
import { retry } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MiscService {

    constructor(private appStorage: AppLocalStorage, private http: HttpClient) {}

    public getMerchantDetails = () => this.appStorage.getFromStorage('user')

    user = undefined;
    userSubject = new BehaviorSubject(this.user)

    updateUser = (update) => {
        this.user = update;
        this.userSubject.next(this.user);
        this.appStorage.storeToStorage('user', this.user);
    }

    genRandomString = (length) =>  Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1)

    // numberWithCommas = (number) => {
    //     if (!number) { return '0'; }
    //     const parts = number.toString().split('.');
    //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    //     return  parseFloat(parts.join('.')).toFixed(2);
    //   }
    numberWithCommas = (x) => {
        if (!x) { return '0'; }
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        parts = parts.join(".")
        if(parts.includes('.'))
            return parts
        else return parts + '.00'
      }

    formatDateAndTime = (date: string | null) => {
        if (!date) { return ''; }
        const dateToFormat = new Date(date);
        return dateToFormat.toDateString() + ' ' + dateToFormat.toLocaleTimeString()
    }
    formatDate = (date: string | null) => {
        if (!date) { return ''; }
        const dateToFormat = new Date(date);
        return dateToFormat.toDateString() 
    }
    formatTime = (date: string | null) => {
        if (!date) { return ''; }
        const dateToFormat = new Date(date);
        return dateToFormat.toLocaleTimeString()
    }

    formatTo2DecimalPlaces = (number: any) => {
        if (!number) { return; }
        number = number.toString()
        if(number.includes('.')){
            number = parseFloat(number)
            return parseFloat(number.toFixed(2)).toString()
        }
        else {
            return number + '.00'
        }
    }
//    function formatTo2DecimalPlaces(number){
//         if (!number) { return; }
//         parseFloat(number).toFixed(2)
//     }

    validateXcelAccount = (walletNumber, schemeCode): Observable<any> => {
        return this.http.get(`${environment.API_URL}/source/details/${walletNumber}/${schemeCode}`).pipe(retry(3))
      }

    formatCountryCode = (countryCode) => countryCode.length == 1? '00' + countryCode : countryCode.length == 2? '0' + countryCode : countryCode

    getSettlementAccounts = () => this.http.get(`${environment.API_URL}/merchant/banks/${this.getMerchantDetails().merchant_id}`)

    createSettlementAccount = (body) => this.http.post(`${environment.API_URL}/merchant/add/bank`, body)

    getMerchantWallets = () => this.http.get(`${environment.API_URL}/merchant/wallets/${this.getMerchantDetails().merchant_id}`)

    createMerchantWallet = (body) => this.http.post(`${environment.API_URL}/merchant/wallet`, body)

    createMerchantWalletUK1 = (body) => this.http.post(`${environment.API_URL}/psp/account`, body)

    createMerchantWalletUK2 = (body) => this.http.post(`${environment.API_URL}/merchants/modulr/account`, body)

    validateAccount = (currencyCode, bankCode, accountNumber) => this.http.get(`${environment.API_URL}/psp/validate/account/${currencyCode}/${bankCode}/${accountNumber}`)

    getBanks = () => this.http.get(`${environment.API_URL}/banks/${this.getMerchantDetails().country_code}`)

    getCountries = () => this.http.get(`${environment.API_URL}/business/countries`)

    performBalanceInquiry = (accountIdentifier) => {
        if(this.getMerchantDetails().currency.iso_code_2 === 'GB'){
            return this.http.get(`${environment.API_URL}/psp/account/balance/${accountIdentifier}`) 
        } else{
            return this.http.get(`${environment.API_URL}/source/wallet/balance/${accountIdentifier}`)
        }
    }

    requestTransactionOTP = (accountIdentifier) => {
        const schemeCode = this.getMerchantDetails().country_code + '004'
        return this.http.get(`${environment.API_URL}/source/otp/${accountIdentifier}/${schemeCode}?group=true`)
    }

    fetchImageUrl(file: any): Observable<any> {
        let form = new FormData();
        form.append('image', file);
        return this.http.post(`${environment.API_URL}/transactions-service/bucket/upload`, form).pipe(retry(3))
    }
}
